import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-center text-xl font-semibold" }
const _hoisted_2 = { class: "detail-info-row" }
const _hoisted_3 = { class: "detail-info-pair" }
const _hoisted_4 = { class: "detail-info-pair__label" }
const _hoisted_5 = { class: "detail-info-pair__value" }
const _hoisted_6 = { class: "detail-info-pair" }
const _hoisted_7 = { class: "detail-info-pair__label" }
const _hoisted_8 = { class: "detail-info-pair__value" }
const _hoisted_9 = { class: "detail-info-row" }
const _hoisted_10 = { class: "detail-info-pair" }
const _hoisted_11 = { class: "detail-info-pair__label" }
const _hoisted_12 = { class: "detail-info-pair__value" }
const _hoisted_13 = { class: "detail-info-pair" }
const _hoisted_14 = { class: "detail-info-pair__label" }
const _hoisted_15 = { class: "detail-info-pair__value" }
const _hoisted_16 = { class: "detail-info-row" }
const _hoisted_17 = { class: "detail-info-pair" }
const _hoisted_18 = { class: "detail-info-pair__label" }
const _hoisted_19 = { class: "detail-info-pair__value" }
const _hoisted_20 = { class: "detail-info-pair" }
const _hoisted_21 = { class: "detail-info-pair__label" }
const _hoisted_22 = { class: "detail-info-pair__value" }
const _hoisted_23 = { class: "detail-info-row" }
const _hoisted_24 = { class: "detail-info-pair" }
const _hoisted_25 = { class: "detail-info-pair__label" }
const _hoisted_26 = { class: "detail-info-pair__value" }
const _hoisted_27 = { class: "detail-info-pair" }
const _hoisted_28 = { class: "detail-info-pair__label" }
const _hoisted_29 = { class: "detail-info-pair__value" }
const _hoisted_30 = { class: "detail-info-row" }
const _hoisted_31 = { class: "detail-info-pair" }
const _hoisted_32 = { class: "detail-info-pair__label" }
const _hoisted_33 = { class: "detail-info-pair__value" }
const _hoisted_34 = { class: "detail-info-pair" }
const _hoisted_35 = { class: "detail-info-pair__label" }
const _hoisted_36 = { class: "detail-info-pair__value" }
const _hoisted_37 = { class: "detail-info-row" }
const _hoisted_38 = { class: "detail-info-pair" }
const _hoisted_39 = { class: "detail-info-pair__label" }
const _hoisted_40 = { class: "detail-info-pair__value" }
const _hoisted_41 = { class: "detail-info-pair" }
const _hoisted_42 = { class: "detail-info-pair__label" }
const _hoisted_43 = { class: "detail-info-pair__value" }
const _hoisted_44 = {
  key: 0,
  class: "detail-info-row detail-info-row--single"
}
const _hoisted_45 = { class: "detail-info-pair" }
const _hoisted_46 = { class: "detail-info-pair__label" }
const _hoisted_47 = { class: "detail-info-pair__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_BienBanCompleteButton = _resolveComponent("BienBanCompleteButton")!
  const _component_Can = _resolveComponent("Can")!
  const _component_BienBanApproveButton = _resolveComponent("BienBanApproveButton")!
  const _component_BienBanConfirmButton = _resolveComponent("BienBanConfirmButton")!
  const _component_PageHeaderApprovals = _resolveComponent("PageHeaderApprovals")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_PageHeaderActions = _resolveComponent("PageHeaderActions")!
  const _component_DetailTopicLottie = _resolveComponent("DetailTopicLottie")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_DinhMucCoDinhSection = _resolveComponent("DinhMucCoDinhSection")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_VatTuNgoaiDinhMucTableV2 = _resolveComponent("VatTuNgoaiDinhMucTableV2")!
  const _component_PhieuXuatKhoTable = _resolveComponent("PhieuXuatKhoTable")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.bienBanDetail && !_ctx.bienBanDetail.phieu_xuat_kho.length)
      ? (_openBlock(), _createBlock(_component_ConfirmationDialog, {
          key: 0,
          "is-display": _ctx.showConfirmationDeleteDialog,
          title: "Xác nhận?",
          onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showConfirmationDeleteDialog = false)),
          onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConfirmationDeleteDialog = false)),
          onOnConfirmButtonClick: _ctx.confirmDelete
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(`Bạn có chắc chắn muốn xoá biên bản số ${_ctx.bienBanDetail.so_bien_ban}?`), 1)
          ]),
          _: 1
        }, 8, ["is-display", "onOnConfirmButtonClick"]))
      : _createCommentVNode("", true),
    (_ctx.hasApprovalActions)
      ? (_openBlock(), _createBlock(_component_PageHeaderApprovals, { key: 1 }, {
          default: _withCtx(() => [
            (
        !_ctx.bienBanDetail?.ngay_ra_xuong &&
        _ctx.bienBanDetail?.is_admin_approved &&
        _ctx.bienBanDetail?.is_approved
      )
              ? (_openBlock(), _createBlock(_component_Can, {
                  key: 0,
                  all: [_ctx.BIEN_BAN_GIAI_THE.DUYET]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BienBanCompleteButton, {
                      "as-menu-item": "",
                      "bien-ban": _ctx.bienBanDetail,
                      "on-success": _ctx.fetchBienBan
                    }, null, 8, ["bien-ban", "on-success"])
                  ]),
                  _: 1
                }, 8, ["all"]))
              : _createCommentVNode("", true),
            (_ctx.shouldShowApproveButton)
              ? (_openBlock(), _createBlock(_component_BienBanApproveButton, {
                  key: 1,
                  "as-menu-item": "",
                  "bien-ban": _ctx.bienBanDetail,
                  "on-success": _ctx.fetchBienBan
                }, null, 8, ["bien-ban", "on-success"]))
              : _createCommentVNode("", true),
            (_ctx.shouldShowConfirmButton)
              ? (_openBlock(), _createBlock(_component_BienBanConfirmButton, {
                  key: 2,
                  "as-menu-item": "",
                  "bien-ban": _ctx.bienBanDetail,
                  "on-success": _ctx.fetchBienBan
                }, null, 8, ["bien-ban", "on-success"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_PageHeaderActions, null, {
      default: _withCtx(() => [
        (
        _ctx.bienBanDetail?.is_admin_approved &&
        _ctx.bienBanDetail?.is_approved &&
        !_ctx.bienBanDetail?.ngay_ra_xuong
      )
          ? (_openBlock(), _createBlock(_component_Can, {
              key: 0,
              all: [_ctx.BIEN_BAN_GIAI_THE.TAO_MOI]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PageHeaderActionItem, {
                  variant: "success",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
          _ctx.push(`/quan-ly/bien-ban-giai-the/${_ctx.idBienBan}/tao-bbgt-bo-sung`)
        ))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faFileCirclePlus }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" BBGT bổ sung ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["all"]))
          : _createCommentVNode("", true),
        _createVNode(_component_PageHeaderActionItem, { onClick: _ctx.onPrintButtonClicked }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faPrint }, null, 8, ["icon"])
          ]),
          default: _withCtx(() => [
            _createTextVNode(" In BBGT ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        (!_ctx.bienBanDetail?.ngay_ra_xuong && _ctx.bienBanDetail?.can_edit)
          ? (_openBlock(), _createBlock(_component_Can, {
              key: 1,
              all: [_ctx.BIEN_BAN_GIAI_THE.SUA]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PageHeaderActionItem, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.push(`/quan-ly/bien-ban-giai-the/cap-nhat/${_ctx.idBienBan}`)))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faPencil }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Chỉnh sửa ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["all"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Can, {
          all: [_ctx.BIEN_BAN_GIAI_THE.XOA]
        }, {
          default: _withCtx(() => [
            (
          !_ctx.bienBanDetail?.phieu_xuat_kho.length && !_ctx.bienBanDetail?.ngay_ra_xuong
        )
              ? (_openBlock(), _createBlock(_component_PageHeaderActionItem, {
                  key: 0,
                  variant: "danger",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showConfirmationDeleteDialog = true))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faTrash }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Xoá BBGT ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["all"])
      ]),
      _: 1
    }),
    _createVNode(_component_PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_PageContentSection, null, _createSlots({
          header: _withCtx(() => [
            _createTextVNode("Thông tin")
          ]),
          illustration: _withCtx(() => [
            _createVNode(_component_DetailTopicLottie, { topic: "bien-ban" })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("ID biên bản:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.bienBanDetail?.id), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Số biên bản:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.bienBanDetail?.so_bien_ban), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ngày vào xưởng:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.moment(_ctx.bienBanDetail?.ngay_vao_xuong).format("DD/MM/YYYY")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ngày ra xưởng:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.bienBanDetail?.ngay_ra_xuong
                ? _ctx.moment(_ctx.bienBanDetail.ngay_ra_xuong).format("DD/MM/YYYY")
                : "Không có"), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Toa xe:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.bienBanDetail?.id_toa_xe)
                    ? (_openBlock(), _createBlock(_component_BaseLink, {
                        key: 0,
                        to: {
                name: 'chi-tiet-toa-xe',
                params: {
                  id: _ctx.bienBanDetail?.id_toa_xe,
                },
              },
                        isOpenInNewTab: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.bienBanDetail?.toa_xe.ma_toa_xe) + " - " + _toDisplayString(_ctx.bienBanDetail?.toa_xe.ten_toa_xe), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Tiêu đề kế hoạch:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.bienBanDetail?.id_ke_hoach_sua_chua)
                    ? (_openBlock(), _createBlock(_component_BaseLink, {
                        key: 0,
                        to: {
                name: 'chi-tiet-ke-hoach-sua-chua',
                params: {
                  id: _ctx.bienBanDetail.id_ke_hoach_sua_chua,
                },
              },
                        isOpenInNewTab: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.bienBanDetail?.ke_hoach_sua_chua?.ten_ke_hoach), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : (_openBlock(), _createBlock(_component_LabelCustom, {
                        key: 1,
                        "is-text-muted": true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Không có")
                        ]),
                        _: 1
                      }))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cấp sửa chữa:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.idCapSuaChua)
                    ? (_openBlock(), _createBlock(_component_BaseLink, {
                        key: 0,
                        to: {
                name: 'chi-tiet-cap-sua-chua',
                params: {
                  id: _ctx.idCapSuaChua,
                },
              },
                        isOpenInNewTab: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.bienBanDetail?.cap_sua_chua?.ten_cap_sc ||
                _ctx.bienBanDetail?.ke_hoach_sua_chua.cap_sua_chua.ten_cap_sc), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ngày lập:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.moment(_ctx.bienBanDetail?.ngay_lap).format("DD/MM/YYYY")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Được duyệt:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_33, [
                  (_ctx.bienBanDetail)
                    ? (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: 0,
                        id: "is-duyet",
                        modelValue: _ctx.bienBanDetail.is_admin_approved,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bienBanDetail.is_admin_approved) = $event)),
                        disabled: "",
                        size: "large"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Xác nhận:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_36, [
                  (_ctx.bienBanDetail)
                    ? (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: 0,
                        id: "is-xac-nhan",
                        modelValue: _ctx.bienBanDetail.is_approved,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bienBanDetail.is_approved) = $event)),
                        disabled: "",
                        size: "large"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ngoài định mức:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_40, [
                  (_ctx.bienBanDetail)
                    ? (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: 0,
                        id: "is-hoan-thanh",
                        modelValue: _ctx.bienBanDetail.has_dinh_muc_dong,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bienBanDetail.has_dinh_muc_dong) = $event)),
                        disabled: "",
                        size: "large"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Đ/mức cố định:")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_43, [
                  (!!_ctx.dinhMucCoDinhDetail)
                    ? (_openBlock(), _createBlock(_component_BaseLink, {
                        key: 0,
                        to: {
                name: 'chi-tiet-dinh-muc-co-dinh',
                params: {
                  id: _ctx.dinhMucCoDinhDetail.id,
                },
              }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.dinhMucCoDinhDetail.danh_muc_toa_xe.ten_danh_muc) + " (" + _toDisplayString(_ctx.dinhMucCoDinhDetail.cap_sua_chua.ten_cap_sc) + ") ", 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : (_openBlock(), _createBlock(_component_LabelCustom, {
                        key: 1,
                        "is-text-muted": true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Không có")
                        ]),
                        _: 1
                      }))
                ])
              ])
            ]),
            (_ctx.bienBanParentDetail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ghi chú:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_LabelCustom, {
                        class: "align-items-center d-flex",
                        "is-bolder": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Đây là BB bổ sung của biên bản số "),
                          _createVNode(_component_BaseLink, {
                            class: "ms-1",
                            to: {
                  name: 'chi-tiet-bien-ban-giai-the',
                  params: { id: _ctx.bienBanParentDetail.id },
                },
                            isOpenInNewTab: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.bienBanParentDetail.so_bien_ban), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (_ctx.shouldShowApprovalNotice)
            ? {
                name: "footer",
                fn: _withCtx(() => [
                  _createVNode(_component_Notice, {
                    title: 'Trạng thái phê duyệt',
                    body: _ctx.approvalNoticeBody,
                    color: "info",
                    padding: 'p-6 mb-0 mt-2'
                  }, null, 8, ["body"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1024),
        (_ctx.idCapSuaChua && _ctx.idDanhMucToaXe)
          ? (_openBlock(), _createBlock(_component_DinhMucCoDinhSection, {
              key: 0,
              "id-bien-ban": _ctx.idBienBan,
              "id-cap-sua-chua": _ctx.idCapSuaChua,
              "id-danh-muc-toa-xe": _ctx.idDanhMucToaXe,
              "id-kho": _ctx.createPhieuXuatIdKho,
              "is-button-disabled": !_ctx.canCreatePhieuXuat,
              "show-create-phieu-xuat-button": !_ctx.bienBanDetail?.ngay_ra_xuong,
              "button-tooltip-message": 
        _ctx.canCreatePhieuXuat ? 'Tạo phiếu xuất' : 'BBGT chưa được duyệt'
      ,
              "status-filter": "valid",
              onOnDoneLoading: _cache[8] || (_cache[8] = 
        ({ data }) => {
          _ctx.dinhMucCoDinhDetail = data;
          _ctx.endLoading();
        }
      )
            }, null, 8, ["id-bien-ban", "id-cap-sua-chua", "id-danh-muc-toa-xe", "id-kho", "is-button-disabled", "show-create-phieu-xuat-button", "button-tooltip-message"]))
          : _createCommentVNode("", true),
        (_ctx.bienBanDetail?.has_dinh_muc_dong)
          ? (_openBlock(), _createBlock(_component_PageContentSection, { key: 1 }, {
              header: _withCtx(() => [
                _createTextVNode("Ngoài định mức")
              ]),
              actions: _withCtx(() => [
                (!_ctx.bienBanDetail?.ngay_ra_xuong)
                  ? (_openBlock(), _createBlock(_component_Can, {
                      key: 0,
                      all: [_ctx.PHIEU_XUAT_KHO.TAO_MOI]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ButtonCustom, {
                          "button-type": _ctx.ButtonsType.ADD,
                          "color-type": _ctx.ButtonTypeColors.SUCCESS,
                          "is-disabled": !_ctx.canCreatePhieuXuat,
                          "tooltip-message": _ctx.canCreatePhieuXuat ? '' : 'BBGT chưa được duyệt',
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (
              _ctx.$router.push({
                name: 'tao-moi-phieu-xuat-kho',
                query: {
                  idBienBan: String(_ctx.idBienBan),
                  loaiDinhMuc: 'ngoai-dinh-muc',
                  ...(_ctx.createPhieuXuatIdKho
                    ? { idKho: String(_ctx.createPhieuXuatIdKho) }
                    : {}),
                },
              })
            ))
                        }, {
                          "button-label": _withCtx(() => [
                            _createTextVNode("Phiếu xuất")
                          ]),
                          _: 1
                        }, 8, ["button-type", "color-type", "is-disabled", "tooltip-message"])
                      ]),
                      _: 1
                    }, 8, ["all"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_VatTuNgoaiDinhMucTableV2, {
                  items: _ctx.bienBanDetail?.ngoai_dinh_muc ?? []
                }, null, 8, ["items"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode("Phiếu xuất kho")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PhieuXuatKhoTable, {
              "cur-page": 1,
              "per-page": 1,
              items: _ctx.bienBanDetail?.phieu_xuat_kho,
              "show-loai-dinh-muc-column": true,
              onRefresh: _ctx.fetchBienBan
            }, null, 8, ["items", "onRefresh"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}